module.exports = __webpack_public_path__ + "static/media/img_frame_white_a700.49ce748f.webp";